import TipoUso from '@/spa/tipo-uso/TipoUsoCadastro';

export default {
  path: 'tipo-uso',
  name: 'tipo-uso',
  component: TipoUso,
};
